import React from 'react';
import ProgressBar from './progress-bar';

/**
 * __Success progress bar__
 *
 * A success progress bar indicates the completion of a process.
 *
 * - [Examples](https://atlassian.design/components/progress-bar/success-progress-bar/examples)
 * - [Code](https://atlassian.design/components/progress-bar/success-progress-bar/code)
 */
var SuccessProgressBar = function SuccessProgressBar(_ref) {
  var ariaLabel = _ref.ariaLabel,
    _ref$isIndeterminate = _ref.isIndeterminate,
    isIndeterminate = _ref$isIndeterminate === void 0 ? false : _ref$isIndeterminate,
    testId = _ref.testId,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? 0 : _ref$value;
  return /*#__PURE__*/React.createElement(ProgressBar, {
    appearance: value < 1 || isIndeterminate ? 'default' : 'success',
    value: value,
    isIndeterminate: isIndeterminate,
    ariaLabel: ariaLabel,
    testId: testId
  });
};
export default SuccessProgressBar;